// @ vendors
const { Promise } = require('es6-promise');

// @ utilities
const { recordProcess, PROC_END, PROC_FAIL } = require('utilities/tagging');

// @ track processes
const { PROC_CHANGE_ECONOMIC_DATA } = require('constants/mortgageRequestProcesses');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

//@actions
const { requestState } = require('actions/mortgageRequest/mortgageRequestState');
const { validateHolderStep, getNextStepValid } = require('actions/mortgageRequest/mortgageHoldersDataValidation');

// @ constants
const {
    MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_REQUEST,
    MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_SUCCESS,
    MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_FAILURE,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_REQUEST,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_SUCCESS,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_FAILURE,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_IRPF_REQUEST,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_IRPF_SUCCESS,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_IRPF_FAILURE,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_130_REQUEST,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_130_SUCCESS,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_130_FAILURE,
    MORTGAGE_REQUEST_DELETE_OTHER_LOAN_REQUEST,
    MORTGAGE_REQUEST_DELETE_OTHER_LOAN_SUCCESS,
    MORTGAGE_REQUEST_ECONOMIC_FLAG,
    MORTGAGE_REQUEST_HOLDER_ECONOMIC_EDIT_SET_FIELD,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_ADD_FILE,
    MORTGAGE_REQUEST_HOLDER_ECONOMIC_RESET,
    MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_RESET,
    MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_OTHER_LOANS_REQUEST,
    MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_OTHER_LOANS_SUCCESS,
    MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_OTHER_LOANS_FAILURE,
    MORTGAGE_REQUEST_HOLDER_ECONOMIC_OTHER_LOANS_SAVE_SUCCESS,
    MORTGAGE_REQUEST_HOLDER_ECONOMIC_OTHER_LOANS_SAVE_FAILURE
} = require('constants/actionTypes');



const requestHolderEconomicInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_REQUEST
});

const requestHolderEconomicSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_SUCCESS,
    data: data
});

const requestHolderEconomicFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_FAILURE,
    data: {
        error
    }
});

const editHolderEconomicInProgress = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_REQUEST
});

const editHolderEconomicSuccess = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_SUCCESS
});

const editHolderEconomicFailure = (error) => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_FAILURE,
    data: {
        error
    }
});

const editHolderEconomicIRPFInProgress = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_IRPF_REQUEST
});

const editHolderEconomicIRPFSuccess = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_IRPF_SUCCESS
});

const editHolderEconomicIRPFFailure = (error) => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_IRPF_FAILURE,
    data: {
        error
    }
});

const editHolderEconomic130InProgress = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_130_REQUEST
});

const editHolderEconomic130Success = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_130_SUCCESS
});

const editHolderEconomic130Failure = (error) => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_WORK_130_FAILURE,
    data: {
        error
    }
});

const deleteOtherLoanInProgress = () => ({
    type: MORTGAGE_REQUEST_DELETE_OTHER_LOAN_REQUEST
});

const deleteOtherLoanSuccess = id => ({
    type: MORTGAGE_REQUEST_DELETE_OTHER_LOAN_SUCCESS,
    data: {
        id
    }
});

const requestEconomicFlag = (flag) => ({
    type: MORTGAGE_REQUEST_ECONOMIC_FLAG,
    flag
});

const setField = (inputField, data) => ({
    type: MORTGAGE_REQUEST_HOLDER_ECONOMIC_EDIT_SET_FIELD,
    payload: {
        inputField,
        data
    }
});

const addFile = (file) => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_ADD_FILE,
    payload: file
});

const resetState = () => ({
    type: MORTGAGE_REQUEST_HOLDER_ECONOMIC_RESET
});

const resetEditState = () => ({
    type: MORTGAGE_REQUEST_EDIT_HOLDER_ECONOMIC_RESET
});

const requestHolderEconomicOtherLoansInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_OTHER_LOANS_REQUEST
});

const requestHolderEconomicOtherLoansSuccess = data => ({
    type: MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_OTHER_LOANS_SUCCESS,
    data
});

const requestHolderEconomicOtherLoansFailure = error => ({
    type: MORTGAGE_REQUEST_FETCH_HOLDER_ECONOMIC_OTHER_LOANS_FAILURE,
    data: {
        error
    }
});

const requestHolderEconomicOtherLoansSaveSuccess = () => ({
    type: MORTGAGE_REQUEST_HOLDER_ECONOMIC_OTHER_LOANS_SAVE_SUCCESS
});

const requestHolderEconomicOtherLoansSaveFailure = error => ({
    type: MORTGAGE_REQUEST_HOLDER_ECONOMIC_OTHER_LOANS_SAVE_FAILURE,
    data: {
        error
    }
});

const reset = () => dispatch => {
    dispatch(resetState());
    dispatch(resetEditState());
};

const requestHolderEconomic = (tipoDocumentoIdentidad, numeroDocumento) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolderEconomic;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                tipoDocumentoIdentidad,
                numeroDocumento
            }
        };

        dispatch(requestHolderEconomicInProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('mortgageRequestHolderEconomic'), requestData)
            .then(response => dispatch(requestHolderEconomicSuccess(response)))
            .catch(error => {
                if (error.error) {
                    dispatch(requestHolderEconomicFailure(error))
                } else {
                    throw error;
                }
            });
    } else {
        return Promise.resolve()
    }
};

const editHolderEconomic = (formState, proprietorNumValue, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolderEconomic;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                codigoCvs: formState.codigoCSV,
                codigoPersona: formState.codigoPersona,
                cuotaMensualAlquiler: formState.cuotaMensualAlquiler,
                cuotaMensualOtroPrestamo: formState.cuotaMensualOtroPrestamo,
                cuotaMensualPrestamoHipotecario: formState.cuotaMensualPrestamoHipotecario,
                datosEconomicosDeclarados: formState.datosEconomicosDeclarados,
                datosObservados: formState.datosObservados,
                importeTotalpendienteOtraHipoteca: formState.importeTotalpendienteOtraHipoteca,
                ingresosNetos: formState.ingresosNetos,
                modelo130: [],
                numeroDocumento: formState.numeroDocumento,
                quiereCancelarOtraHipoteca: formState.quiereCancelarOtraHipoteca,
                regimenInmueble: formState.regimenInmueble,
                tieneOtraHipoteca: formState.tieneOtraHipoteca,
                tipoDocumentoIdentidad: formState.tipoDocumentoIdentidad,
                confirmada: formState.confirmada
            }
        };

        const url = apiURLBuilder.getURL('mortgageRequestHolderEconomicEdit');

        dispatch(editHolderEconomicInProgress());
        return APIPost(dispatch, url, requestData)
            .then(() => {
                dispatch(editHolderEconomicSuccess());
                recordProcess(PROC_CHANGE_ECONOMIC_DATA, PROC_END);
                const holderNumber = parseInt(proprietorNumValue, 10);
                const holderKey = proprietorNumValue === 2 ? 'isCoHolder' : 'isHolder';
                dispatch(validateHolderStep(2, holderKey));
                const linkRedirection = dispatch(getNextStepValid(holderNumber));
                dispatch(requestState(linkRedirection, history));
            })
            .catch(error => {
                if (error.error) {
                    recordProcess(PROC_CHANGE_ECONOMIC_DATA, PROC_FAIL);
                    dispatch(editHolderEconomicFailure(error))
                } else {
                    throw error;
                }
            });
    } else {
        return Promise.resolve()
    }
};

const editHolderEconomicIRPF = (idExpediente, tipoArchivo, numeroDocumento, tipoDocumento) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolderEconomicEdit;
    const isAlreadyFetching = currentState.get('isFetchingIRPF');
    if (!isAlreadyFetching) {

        const formData = new FormData();
        const files = currentState.get('files');

        if (files) {
            files.map(function (fileContainer) {
                if (fileContainer.name === 'irpf') {
                    formData.append('files', fileContainer.data.file);
                }
            });
        }

        const model = {
            tipoArchivo: tipoArchivo,
            idExpediente: idExpediente,
            tipoDocumento: tipoDocumento,
            numeroDocumento: numeroDocumento
        };
        formData.append(
            'model',
            new Blob([
                JSON.stringify(model)
            ], {
                    type: 'application/json'
                })
        );

        const requestData = {
            query: formData
        };

        const url = apiURLBuilder.getURL('mortgageRequesWorkDataFileMultipleSubmit');

        dispatch(editHolderEconomicIRPFInProgress());
        return APIPost(dispatch, url, requestData, false)
            .then(() => dispatch(editHolderEconomicIRPFSuccess()))
            .catch((response) => {
                if (!!response.error) {
                    dispatch(editHolderEconomicIRPFFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve()
    }
};

const editHolderEconomic130 = (idExpediente, tipoArchivo, numeroDocumento, tipoDocumento) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolderEconomicEdit;
    const isAlreadyFetching = currentState.get('isFetching130');
    if (!isAlreadyFetching) {

        const formData = new FormData();
        const files = currentState.get('files');

        if (files) {
            files.map(function (fileContainer) {
                if (fileContainer.name === 'modelo130') {
                    formData.append('files', fileContainer.data.file);
                }
            });
        }

        const model = {
            tipoArchivo: tipoArchivo,
            idExpediente: idExpediente,
            tipoDocumento: tipoDocumento,
            numeroDocumento: numeroDocumento
        };
        formData.append(
            'model',
            new Blob([
                JSON.stringify(model)
            ], {
                    type: 'application/json'
                })
        );

        const requestData = {
            query: formData
        };

        const url = apiURLBuilder.getURL('mortgageRequesWorkDataFileMultipleSubmit');

        dispatch(editHolderEconomic130InProgress());
        return APIPost(dispatch, url, requestData, false)
            .then(() => dispatch(editHolderEconomic130Success()))
            .catch((response) => {
                if (!!response.error) {
                    dispatch(editHolderEconomic130Failure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve()
    }
};

const requestOtherLoans = (documentType, documentNumber, id) => dispatch => {
    const params = {
        query: {
            documentNumber,
            documentType,
            id
        }
    };

    dispatch(requestHolderEconomicOtherLoansInProgress());

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestHolderEconomicOtherLoans',
        params
    })
        .then(response => dispatch(requestHolderEconomicOtherLoansSuccess(response.data)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestHolderEconomicOtherLoansFailure(response.error));
            } else {
                throw response;
            }
        });
}

const deleteOtherLoan = (params, history) => dispatch => {
    const { documentNumber, documentType, id } = params;

    const requestData = {
        query: {
            documentNumber,
            documentType,
            id
        }
    }

    dispatch(deleteOtherLoanInProgress());

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestHolderEconomicOtherLoansDelete',
        params: requestData
    })
        .then(() => {
            dispatch(deleteOtherLoanSuccess(id));
        })
        .catch(response => {
            if (!!response.error) {
                history.push('/myprofile/mortgage-error');
            } else {
                throw response;
            }
        });
};

const saveOtherLoans = (dataLoan, dataFile) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestHolderEconomicEdit;
    const isAlreadySaving = currentState.get('isSavingOtherLoan');

    if (!isAlreadySaving) {

        const formData = new FormData();

        if (dataFile && dataFile.file) {
            formData.append('file', dataFile.file.file);
        }

        formData.append(
            'loan',
            new Blob([
                JSON.stringify(dataLoan)
            ], {
                    type: 'application/json'
                })
        );

        const requestData = {
            query: formData
        };

        const url = apiURLBuilder.getURL('mortgageRequestHolderEconomicSaveOtherLoans');

        return APIPost(dispatch, url, requestData, false)
            .then(() => {
                dispatch(requestHolderEconomicOtherLoansSaveSuccess());
                dispatch(requestOtherLoans(dataLoan.documentType, dataLoan.documentNumber));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestHolderEconomicOtherLoansSaveFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        // return Promise.resolve()
    }
};

module.exports = {
    requestHolderEconomic,
    editHolderEconomic,
    editHolderEconomicIRPF,
    editHolderEconomic130,
    deleteOtherLoan,
    setField,
    addFile,
    requestEconomicFlag,
    reset,
    requestOtherLoans,
    saveOtherLoans
};
